module.exports = __webpack_public_path__ + "img/banner-3.ce141c40.jpg";